<template>
  <v-list dark two-line>
    <v-list-item-group v-model="selected" active-class="pink--text">
      <template v-for="(item, index) in emails">
        <v-list-item :key="item.id" @click="selectEmail(item)">
          <v-list-item-content>
            <v-list-item-title v-text="item.from"></v-list-item-title>
            <v-list-item-subtitle v-text="item.subject"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text v-text="formatDate(item.date)"></v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="index + 1 < emails.length" :key="index"></v-divider>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex"
import moment from "moment"

export default {
  name: "Mailbox",
  data: () => ({
    selected: null,
  }),
  computed: {
    ...mapGetters("mailStore", ["emails"]),
  },
  methods: {
    selectEmail(email) {
      this.$store.dispatch("mailStore/selectEmail", email)
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY")
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list {
  background-color: transparent !important;
  color: #ffffff !important;
  padding: 0;
}

.v-list-item {
  border-bottom: 1px solid #3a3a3a;
}

.v-list-item--active {
  background-color: #0d47a1 !important;
}

.v-list-item__title {
  font-weight: 500;
}

.v-list-item__subtitle {
  color: #b0b0b0 !important;
}

.v-list-item__action-text {
  color: #b0b0b0 !important;
}
</style>
